<template>
    <div>
        <v-col cols="12">
            <v-row>
                <v-col cols="4">
                    <v-menu
                        ref="createdDatePicker"
                        v-model="createdDatePicker"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        persistent
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dateRangeText"
                                label="Report Time Range"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                hide-details
                                dense>
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dates"
                            range
                            scrollable
                            @change="
                                showProductReport = false;
                                showProductFBSummaryReport = false;
                                showProductFBDayByDayReport = false;
                                showGGCampPerformReport = false;"
                            v-if="createdDatePicker">
                        </v-date-picker>
                    </v-menu>
                </v-col>

                <v-col cols="2">
                    <v-btn color="success" v-if="dates.length > 1" @click="loadData">Show Data</v-btn>
                    <v-btn v-else disabled>Show Data</v-btn>
                </v-col>

                <v-col cols="12">
                    <v-simple-table fixed-header height="95vh">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="cell-border">User</th>
                                    <th class="cell-border">Job Type</th>
                                    <th class="cell-border">Idea</th>
                                    <th class="cell-border">Scaler</th>
                                    <th class="cell-border">Uploader</th>
                                    <th class="cell-border">Post User</th>                                    
                                </tr>
                            </thead>

                            <tbody>
                                <template v-for="(item,index) of kpiReport">
                                    <tr :key="index">
                                        <td class="cell-border" :rowspan="item.row">
                                            {{ item.username }}
                                        </td>
                                        <td class="cell-border">
                                            <template v-if="item.jobs.length > 0">
                                            {{ item.jobs[0].job_type}}
                                            </template>
                                            <!-- {{ item.jobs[0].job_type }} -->
                                        </td>

                                        <td class="cell-border">
                                            <template v-if="item.jobs.length > 0">
                                            {{ item.jobs[0].idea }}
                                            </template>
                                        </td>
                                        <td class="cell-border">
                                            <template v-if="item.jobs.length > 0">
                                            {{ item.jobs[0].scaler}}
                                            </template>
                                            <!-- {{ item.jobs[0].scaler }} -->
                                        </td>
                                        <td class="cell-border">
                                            <template v-if="item.jobs.length > 0">
                                            {{ item.jobs[0].uploader}}
                                            </template>
                                            <!-- {{ item.jobs[0].uploader }} -->
                                        </td>
                                        <td class="cell-border">
                                            <template v-if="item.jobs.length > 0">
                                            {{ item.jobs[0].post_fb}}
                                            </template>
                                            <!-- {{ item.jobs[0].post_fb }} -->
                                        </td>                                        
                                    </tr>

                                    <template v-for="(i,indexi) of item.jobs">
                                        <tr v-if="indexi > 0" :key="index+'-'+indexi">
                                            <td class="cell-border">
                                                {{ i.job_type }}
                                            </td>
                                            <td class="cell-border">
                                                {{ i.idea }}
                                            </td>
                                            <td class="cell-border">
                                                {{ i.scaler }}
                                            </td>
                                            <td class="cell-border">
                                                {{ i.uploader }}
                                            </td>
                                            <td class="cell-border">
                                                {{ i.post_fb }}
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>

            </v-row>   
        </v-col>    
    </div>
</template>

<script>

    import axios from "axios";

    export default {
        name:"KPIReport",

        data: () => ({
            createdDatePicker:false,
            dates:[],
            sortBy:'',
            kpiReport:[],
        }),

        computed: {
            dateRangeText() {
            return this.dates.join(" ~ ");
            },
        },

        methods:{
            sortData(col) {
                this.sortBy = col;
                if (this.sortType == null) {
                    this.sortType = false;
                } else {
                    this.sortType = !this.sortType;
                }

                if (this.sortType == false)
                    this.kpiReport.sort((a, b) => (a[col] > b[col] ? 1 : -1));
                else this.kpiReport.sort((a, b) => (a[col] < b[col] ? 1 : -1));
            }, 


            async loadData(){
                var currentSession = await this.$root.$refs.App.currentSession(
                    "kpi-report-loadData"
                );
                if (currentSession.accessToken) {

                    let queryParams = {}

                    if (this.dates.length > 0) {
                        if (this.dates[0] > this.dates[1]) {
                        queryParams["report_from"] = this.dates[1];
                        queryParams["report_to"] = this.dates[0];
                        } else {
                        queryParams["report_from"] = this.dates[0];
                        queryParams["report_to"] = this.dates[1];
                        }
                    }

                    await axios
                    .get(window.domain + "/ideas_v2/report_kpi", {
                        headers: { Authorization: currentSession.accessToken },
                        params: queryParams,
                    }).then(response => {
                        console.log('response: ',response)
                        //this.ideaReports = response.data.ideas
                        this.kpiReport = response.data.data.map(t => {
                            t['row'] = t.jobs.length == 0 ? 1 : t.jobs.length
                            return t
                        })
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.cell-border{
    border: thin solid rgba(0, 0, 0, 0.12);
}

.cell-color{
    background-color: #D9EAD3;
}

</style>